const { fullVersion, sentryRelease } = _WEBPACK_APP_VERSION_;

export default fullVersion;
export { sentryRelease };



// WEBPACK FOOTER //
// ./src/version.js